/**
 * Rank "You Might Also Like" toward the product on the page.
 * Shopify related recs on this store often ignore audience (kids vs adult)
 * and dump gift-pool bestsellers, so collection seeds + scoring do the work.
 */
(function (root) {
  function tagsOf(product) {
    if (Array.isArray(product.tags)) return product.tags;
    if (typeof product.tags === 'string') {
      return product.tags.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
    }
    return [];
  }

  function titleBlob(product) {
    return [product.title || '', product.handle || ''].join(' ').toLowerCase();
  }

  function isGloveLike(text) {
    return /\b(glove|gloves|mitten|mittens)\b/.test(String(text || '').toLowerCase());
  }

  function isKidsProduct(product) {
    var tags = tagsOf(product).map(function (tag) { return String(tag).toLowerCase(); });
    if (tags.indexOf('kids') !== -1) return true;
    if (tags.indexOf('gift:interest:kids') !== -1) return true;
    return /\b(kids?|child|children|toddler|baby|babies)\b/.test(titleBlob(product));
  }

  function primarySegment(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).indexOf('rarely_primary_segment:') === 0) {
        return String(tags[i]).slice('rarely_primary_segment:'.length);
      }
    }
    return '';
  }

  function productTypeOf(product) {
    return String(product.product_type || product.type || '').trim().toLowerCase();
  }

  function usefulVendor(value) {
    var vendor = String(value || '').trim().toLowerCase();
    if (!vendor || vendor === 'rarely' || vendor === 'rarely marketplace') return '';
    return vendor;
  }

  function isWorkshopLike(product) {
    var tags = tagsOf(product).map(function (tag) { return String(tag).toLowerCase(); });
    var blob = titleBlob(product);
    if (isGloveLike(blob)) return true;
    if (tags.indexOf('gift:interest:workshop') !== -1) return true;
    if (/workshop|apparel_gloves/.test(primarySegment(tags))) return true;
    return /\b(axe|hatchet|knife|knives|tool[- ]?roll|work belt|apron|impact|wrench|driver|shears?)\b/.test(blob);
  }

  function accessoryHandlesFor(current) {
    if (!root.RarelyAccessoryMap || !root.RarelyAccessoryMap.match) return [];
    var rule = root.RarelyAccessoryMap.match({
      handle: current.handle || '',
      title: current.title || '',
      vendor: current.vendor || '',
      tags: current.tags || []
    });
    return rule && rule.addons ? rule.addons : [];
  }

  function scoreProduct(product, current) {
    var title = titleBlob(product);
    var tags = tagsOf(product);
    var currentTags = current.tags || [];
    var score = 0;
    var currentKids = isKidsProduct(current);
    var productKids = isKidsProduct(product);
    var currentIsGlove = isGloveLike(current.title || '');
    var currentSeg = primarySegment(currentTags);
    var productSeg = primarySegment(tags);
    var wanted = accessoryHandlesFor(current);
    var handle = String(product.handle || '').toLowerCase();

    if (wanted.indexOf(handle) !== -1) score += 200;

    if (currentKids && productKids) score += 180;
    if (currentKids && !productKids) score -= 250;
    if (!currentKids && productKids && wanted.indexOf(handle) === -1) score -= 80;

    // Family boosts apply only when the page is already in that family.
    if (currentIsGlove && isGloveLike(title)) score += 120;
    if (isWorkshopLike(current) && !currentKids) {
      if (/\b(axe|hatchet|knife|knives|tool[- ]?roll|work belt|apron|impact|wrench|driver|shears?)\b/.test(title)) {
        score += 70;
      } else if (currentIsGlove && tags.map(function (tag) { return String(tag).toLowerCase(); }).indexOf('gift:interest:workshop') !== -1) {
        score += 40;
      }
    }

    var currentVendor = usefulVendor(current.vendor);
    if (currentVendor && currentVendor === usefulVendor(product.vendor)) score += 80;

    var currentType = productTypeOf(current);
    if (currentType && currentType === productTypeOf(product)) score += 50;

    if (currentSeg && productSeg && currentSeg === productSeg) score += 40;

    currentTags.forEach(function (tag) {
      if (String(tag).indexOf('gift:interest:') !== 0) return;
      if (tags.indexOf(tag) === -1) return;
      score += 20;
    });

    if (currentIsGlove && !currentKids && (productSeg === 'kitchen_coffee' || /balsamic|olive oil|vinegar|coffee/.test(title))) {
      score -= 80;
    }

    return score;
  }

  root.RarelySuggestedRank = {
    isKidsProduct: isKidsProduct,
    isGloveLike: isGloveLike,
    isWorkshopLike: isWorkshopLike,
    scoreProduct: scoreProduct
  };

  var section = root.document && root.document.getElementById('suggested-products');
  var grid = root.document && root.document.getElementById('suggested-products-grid');
  if (!section || !grid) return;

  var productId = Number(section.getAttribute('data-product-id') || 0);
  var productAvailable = section.getAttribute('data-available') === 'true';
  var currentTitle = section.getAttribute('data-title') || '';
  var currentTags = (section.getAttribute('data-tags') || '')
    .split('|')
    .map(function (tag) { return tag.trim(); })
    .filter(Boolean);

  var seed = [];
  var seedEl = root.document.getElementById('rarely-suggested-seed');
  if (seedEl) {
    try {
      seed = JSON.parse(seedEl.textContent || '[]') || [];
    } catch (err) {
      seed = [];
    }
  }

  function mergeProducts(groups) {
    var seen = {};
    var merged = [];
    groups.forEach(function (list) {
      (list || []).forEach(function (product) {
        if (!product || !product.available) return;
        if (product.id === productId) return;
        if (seen[product.id]) return;
        seen[product.id] = true;
        merged.push(product);
      });
    });
    return merged;
  }

  function pickProducts(products) {
    var current = {
      title: currentTitle,
      tags: currentTags,
      handle: section.getAttribute('data-handle') || '',
      vendor: section.getAttribute('data-vendor') || '',
      product_type: section.getAttribute('data-type') || ''
    };
    if (section.getAttribute('data-audience') === 'kids' && current.tags.indexOf('kids') === -1) {
      current.tags = current.tags.concat(['kids']);
    };
    return products
      .map(function (product, index) {
        return { product: product, index: index, score: scoreProduct(product, current) };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      })
      .map(function (entry) { return entry.product; })
      .slice(0, 4);
  }

  function imageUrl(product) {
    var src = product.featured_image;
    if (!src) return '';
    if (src.indexOf('http') !== 0 && src.indexOf('//') !== 0) src = 'https:' + src;
    if (src.indexOf('width=') === -1) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
    }
    return src;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Shopify recs JSON has `description` (HTML) and no `body_html`. Seeded
  // collection mates store already-stripped text in `body_html`. Always
  // decode/strip then truncate so tags never render as visible copy.
  function stripHtml(html) {
    var tmp = root.document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function truncateText(text, len) {
    if (!text || text.length <= len) return text || '';
    return text.slice(0, len).replace(/\s+\S*$/, '') + '...';
  }

  function cardDescription(product) {
    return truncateText(stripHtml(product.body_html || product.description || ''), 120);
  }

  function render(products) {
    if (!products.length) return;
    if (!productAvailable) {
      var heading = section.querySelector('.section-heading');
      if (heading) heading.textContent = 'Available Now';
    }
    section.style.display = '';
    products.forEach(function (product) {
      var desc = cardDescription(product);
      var safeTitle = escapeHtml(product.title);
      var img = imageUrl(product)
        ? '<img src="' + escapeHtml(imageUrl(product)) + '" alt="' + safeTitle + '" loading="lazy">'
        : '';
      var card = root.document.createElement('a');
      card.className = 'product-item';
      card.href = product.url;
      card.innerHTML =
        '<div class="product-item-image">' + img + '</div>' +
        '<div class="product-item-info">' +
          '<span class="product-item-title"></span>' +
          (desc ? '<p class="product-item-desc"></p>' : '') +
        '</div>';
      card.querySelector('.product-item-title').textContent = product.title || '';
      if (desc) card.querySelector('.product-item-desc').textContent = desc;
      grid.appendChild(card);
    });
  }

  var recsUrl = '/recommendations/products.json?product_id=' + productId + '&limit=10';
  fetch(recsUrl)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      var products = pickProducts(mergeProducts([seed, data.products || []]));
      render(products);
    })
    .catch(function (err) {
      console.warn('Recommendations error:', err);
      render(pickProducts(mergeProducts([seed])));
    });
})(typeof window !== 'undefined' ? window : this);
